/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-01-18T11:03:23-08:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-03-17T16:49:09-07:00
 */



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import {css, StyleSheet } from 'aphrodite/no-important';
import { dimensions } from '../../../style';
import { browserHistory } from 'react-router';


const style = StyleSheet.create({
  popover: {
    overflow: 'hidden',
    position: 'absolute',
    zIndex: '900',
    visibility: 'hidden',
    display: 'none',
    padding: '14px',
    right: '0',
    width: '300px',
    top: '64px',
    left: 'auto',
    height: 'auto',

    [dimensions.SCREEN_MAX_MD]: {
    }
  },

  is_active: {
    opacity: '1',
    visibility: 'visible',
    display: 'block',
  },

  popover__globalNav: {
    top: '0',

    [dimensions.SCREEN_MAX_MD]: {
      width: '100%',
      height: 'auto',
      boxSizing: 'border-box',
      left: '0',
      right: '0',
      padding: '0',
    }
  },


  popover_arrow: {
    position: 'absolute',
    top: '1px',
    left: '50%',
    marginLeft: '-7px',

    ':after' : {
      transform: 'rotate(45deg) translate(6px,6px)',
      boxShadow: '-1px -1px 1px -1px rgba(0,0,0,.44)',
      content: "' '",
      display: 'block',
      width: '14px',
      height: '14px',
      background: '#fff',
    }
  },

  popover_inner: {
    padding: '8px 0',
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.09)',
    borderRadius: '3px',
    boxShadow: '0 1px 1px -1px rgba(0,0,0,.44)',
  },

  list: {
    listStyle: 'none',
    margin: '0',
    padding: '0'
  },

  btn: {
    padding: '8px 22px',
    display: 'block',
    cursor: 'pointer'
  }
});


class HeaderNavSubmenu extends Component {

  constructor(props) {
    super(props);
    this.viewProfile = this.viewProfile.bind(this);
    this.renderUpgradeLink = this.renderUpgradeLink.bind(this);
  }

  viewProfile(e) {
    e.preventDefault();
    browserHistory.push(`/~${this.props.username}`)
  }

  renderUpgradeLink() {
    // render upgrade link - if not premium.
    if(!this.props.alreadyUpgraded)
      return (
        <li className={css(style.listItem)}>
          <Link className={css(style.btn)} to="/billing">
            Upgrade Account
          </Link>
        </li>
      );
  }

  render() {

    const classes = [
      style.popover__globalNav,
      style.popover__menu,
      this.props.active && style.is_active
    ]

    return (

      <div className={css(style.popover, classes)}>
        <div className={css(style.popover_inner)}>

          <ul className={css(style.list)}>
            <li className={css(style.listItem)}>
              <a className={css(style.btn)} onClick={this.viewProfile}>
                My Profile
              </a>
            </li>
            <li className={css(style.listItem)}>
              <Link className={css(style.btn)} to="/dashboard">
                Dashboard
              </Link>
            </li>
            <li className={css(style.listItem)}>
              <Link className={css(style.btn)} to="/settings">
                Settings
              </Link>
            </li>
            <li className={css(style.listItem)}>
              <a className={css(style.btn)} target="_blank" href="https://www.misstravel.com/faq/">
                Help
              </a>
            </li>

            {/* render upgrade link - if not premium */}
            {this.renderUpgradeLink()}

            <li className={css(style.listItem)}>
              <Link className={css(style.btn)} to="/logout">
                Logout
              </Link>
            </li>
          </ul>
        </div>
        <div className="popover-arrow"></div>
      </div>

    );
  }
}

HeaderNavSubmenu.propTypes = {
  active: PropTypes.bool.isRequired
}


export default HeaderNavSubmenu;



// WEBPACK FOOTER //
// ./src/components/blocks/HeaderNav/HeaderNavSubmenu.jsx